import { CheckIcon, PlusIcon } from '@heroicons/react/24/outline'

import cn from '@/utilities/cn'

import Button from './Button'

type PillProps = {
  label: string
  selected?: boolean
  disabled?: boolean
  className?: string
  onClick: () => void
}

export default function Pill({ label, selected = false, className, disabled = false, onClick }: PillProps) {
  return (
    <Button
      className={cn(
        disabled
          ? 'cursor-default border-zinc-400 text-zinc-500 disabled:border-zinc-400 disabled:bg-zinc-50 disabled:text-zinc-500 disabled:hover:border-zinc-400'
          : selected
            ? 'cursor-pointer border-brand-400 bg-brand-400 text-white hover:border-brand-500 hover:bg-brand-500'
            : 'cursor-pointer border-brand-400 text-brand-400 hover:border-brand-500 hover:bg-zinc-50 hover:text-brand-500',
        'rounded-full border px-0 py-0 text-sm font-semibold transition-all duration-75',
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-1 py-1 px-3">
        <div>{label}</div>
        {selected ? (
          <CheckIcon className="h-4 w-4 stroke-2" />
        ) : disabled ? null : (
          <PlusIcon className="h-4 w-4 stroke-2" />
        )}
      </div>
    </Button>
  )
}
